import env from './environment'
const settingsList = {
  localhost: {
    API_URL: '',
  },
  development: {
    API_URL: "https://dev-health-api.system.touchetv.com/health",
  },
  staging: {
    API_URL: "https://dev-health-api.system.touchetv.com/health",
  },
  production: {
    API_URL: "https://health-api.system.touchetv.com/health",
  }
}

const settings = settingsList[env]

export default settings
